import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { OnboardingPresenter } from '../onboarding.presenter';
@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html',
  styleUrls: ['./step4.component.scss'],
})
export class Step4Component {
  options = ['From a friend', 'Media or our blog', 'Other'];
  selectedOption: string | null = null;
  isLoading: boolean = false;
  isSkip = false;
  constructor(private router: Router, private location: Location, private onBoardingPresenter: OnboardingPresenter) { }

  ngOnInit(): void {
    const data = this.onBoardingPresenter.getFormData().section3;
    if (data != "") {
      this.selectedOption = data;
    }

  }

  nextStep(option: string) {
    this.selectedOption = option;
  }

  onContinue() {
    this.isLoading = true;
    this.isSkip = false;
    if (this.selectedOption != null) {
      this.router.navigate(['/onboarding/step4']);
      this.onBoardingPresenter.updateSection3(this.selectedOption);
    }

  }
  onSkip() {
    this.isLoading = true;
    this.isSkip = true;
    this.router.navigate(['/onboarding/step4']);
    this.onBoardingPresenter.updateSection3("");
  }


  goBack() {
    this.isLoading = false;
    this.location.back();
  }
}
